export default __webpack_public_path__ + "static/media/hockey2.4de12ccb.png";